import React from "react";

import { AppUserSession } from "@/schemas/auth/session";
import { RecommendationCategoryFeed } from "@/schemas/user/explore";
import ExploreCategoryScreenBase from "@/screens/Explore/ExploreCategory/Components/CategoryScreen/ExploreByCategoryScreenBase";
import SmallProfileCard from "@/screens/Explore/Components/ProfileCard/SmallProfileCard";
import { shouldShowCategoryUnlockingFlow } from "@/utils/explore";

type Props = {
  session: AppUserSession;
  categoryData: RecommendationCategoryFeed;
  isDevTab?: boolean;
  isMarketingMode?: boolean;
};

function ExploreTwoColumnCategoryScreen({
  session,
  categoryData,
  isDevTab = false,
  isMarketingMode = false,
}: Props): React.JSX.Element {
  const showUnlockingFlow = shouldShowCategoryUnlockingFlow(
    categoryData.category,
  );

  return (
    <ExploreCategoryScreenBase
      session={session}
      categoryData={categoryData}
      isDevTab={isDevTab}
      isMarketingMode={isMarketingMode}
      numOfColumns={2}
      renderProfileCard={({
        item,
        itemWidth,
        itemHeight,
        onLockedProfileClick,
      }) => (
        <SmallProfileCard
          profile={item}
          itemWidth={itemWidth}
          itemHeight={itemHeight}
          {...(showUnlockingFlow && {
            cardState: item.isLocked ? "locked" : "normal",
          })}
          {...(showUnlockingFlow && {
            onNonNormalStateCardClick: onLockedProfileClick,
          })}
        />
      )}
    />
  );
}

export default ExploreTwoColumnCategoryScreen;
